import {createSelector} from '@reduxjs/toolkit';
import {getAllBuildings, getDefaultBuilding} from '../../data/buildings/selectors';
import {getSettings} from '../../data/settings/selectors';
import {getIsUpdatingUser, getUser} from '../../data/user';
import {RootState} from '../../rootReducer';
import {toUIBuildingSelectionItems} from './mappers';

export const getIsUpdatingDefaultBuilding = getIsUpdatingUser;

export const getSelectedBuildingId = (state: RootState) => state.ui.profile.selectedBuildingId;

export const getIsDirty = (state: RootState) => state.ui.profile.isDirty;

export const getUserFriendlyName = createSelector(getUser, ({firstName, lastName, email}) => {
  const fullName = [firstName, lastName].filter((part) => part && part !== '').join(' ');
  return fullName && fullName !== '' ? fullName : email;
});

export const getUserFirstName = createSelector(getUser, ({firstName, email}) =>
  firstName && firstName !== '' ? firstName : email,
);

export const getUserInitials = createSelector(
  getUser,
  ({firstName, lastName}) => firstName.charAt(0) + lastName.charAt(0),
);

export const getDefaultBuildingName = createSelector(getDefaultBuilding, (building) =>
  building && building.name ? building.name : '',
);

export const getProfileConfig = createSelector(
  getSettings,
  getAllBuildings,
  ({contactEmailAddress, companyWebsite}, buildings) => {
    return {
      isSupportSectionShown: contactEmailAddress ? true : false,
      isMoreInfoSectionShown: companyWebsite ? true : false,
      isBuildingSelectorShown: buildings && buildings.length > 1,
    };
  },
);

export const getBuildingsForSelection = createSelector(getAllBuildings, toUIBuildingSelectionItems);

export const getCanSaveDefaultBuilding = createSelector(
  getIsUpdatingDefaultBuilding,
  getIsDirty,
  (isUpdating, isDirty) => isDirty && !isUpdating,
);
